import React from 'react';
import {Button} from 'semantic-ui-react';

/**
 * Inline formatting toolbar for a scene editor. Mirrors the Draft inline
 * toolbar buttons (see components/textEditor/inlineToolbarButtons.js):
 * bold / italic / underline / H2 / H3. onMouseDown is prevented so clicking a
 * button keeps the editor selection.
 */
const preventDefault = event => event.preventDefault();

const SceneToolbar = ({editor}) => {
  if (!editor) return null;

  const run = fn => event => {
    event.preventDefault();
    fn();
  };

  return (
    <Button.Group basic size="small" className="scene-toolbar">
      <Button
        icon="bold"
        active={editor.isActive('bold')}
        onMouseDown={preventDefault}
        onClick={run(() => editor.chain().focus().toggleBold().run())}
      />
      <Button
        icon="italic"
        active={editor.isActive('italic')}
        onMouseDown={preventDefault}
        onClick={run(() => editor.chain().focus().toggleItalic().run())}
      />
      <Button
        icon="underline"
        active={editor.isActive('underline')}
        onMouseDown={preventDefault}
        onClick={run(() => editor.chain().focus().toggleUnderline().run())}
      />
      <Button
        active={editor.isActive('heading', {level: 2})}
        onMouseDown={preventDefault}
        onClick={run(() =>
          editor.chain().focus().toggleHeading({level: 2}).run()
        )}
      >
        <span style={{fontSize: '1em'}}>H</span>
      </Button>
      <Button
        active={editor.isActive('heading', {level: 3})}
        onMouseDown={preventDefault}
        onClick={run(() =>
          editor.chain().focus().toggleHeading({level: 3}).run()
        )}
      >
        <span style={{fontSize: '0.8em'}}>H</span>
      </Button>
    </Button.Group>
  );
};

export default SceneToolbar;
